module.exports = __webpack_public_path__ + "img/katarina_bedrooms_20.8e84a7b9.jpg";